if (!customElements.get('purchase-agreement')) {
  customElements.define(
    'purchase-agreement',
    class PurchaseAgreement extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('.purchase-agreement__checkbox');
        this.errorMessage = this.querySelector('.purchase-agreement__error');

        if (!this.checkbox) return;

        this.onCheckboxChange = this.onCheckboxChange.bind(this);
        this.onFormClick = this.onFormClick.bind(this);
        this.onFormSubmit = this.onFormSubmit.bind(this);

        this.checkbox.addEventListener('change', this.onCheckboxChange);
        this.bindForm();
        this.syncPaymentButtons();
      }

      disconnectedCallback() {
        this.checkbox?.removeEventListener('change', this.onCheckboxChange);
        this.form?.removeEventListener('click', this.onFormClick, true);
        this.form?.removeEventListener('submit', this.onFormSubmit, true);
        this.paymentObserver?.disconnect();
      }

      bindForm() {
        const form = document.getElementById(this.dataset.formId);
        if (!form || form === this.form) return;

        this.form?.removeEventListener('click', this.onFormClick, true);
        this.form?.removeEventListener('submit', this.onFormSubmit, true);
        this.paymentObserver?.disconnect();

        this.form = form;
        this.form.addEventListener('click', this.onFormClick, true);
        this.form.addEventListener('submit', this.onFormSubmit, true);
        this.paymentObserver = new MutationObserver(() => this.syncPaymentButtons());
        this.paymentObserver.observe(this.form, { childList: true, subtree: true });
      }

      onCheckboxChange() {
        this.toggleError(false);
        this.syncPaymentButtons();
      }

      onFormClick(event) {
        if (this.checkbox.checked) return;

        const blockedControl = event.target.closest(
          '.product-form__submit, .shopify-payment-button, shopify-accelerated-checkout, .shopify-payment-button__button'
        );
        if (!blockedControl) return;

        event.preventDefault();
        event.stopPropagation();
        this.reportValidity();
      }

      onFormSubmit(event) {
        if (this.reportValidity()) return;

        event.preventDefault();
        event.stopImmediatePropagation();
      }

      syncPaymentButtons() {
        this.bindForm();
        if (!this.form) return;

        const locked = !this.checkbox.checked;
        this.form.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout').forEach((element) => {
          element.classList.toggle('purchase-agreement-locked', locked);
          element.setAttribute('aria-disabled', locked ? 'true' : 'false');
        });
      }

      toggleError(show) {
        if (!this.errorMessage) return;
        this.errorMessage.toggleAttribute('hidden', !show);
        this.checkbox.setAttribute('aria-invalid', show ? 'true' : 'false');
      }

      reportValidity() {
        const valid = this.checkbox.checked;
        this.toggleError(!valid);
        if (!valid) this.checkbox.focus();
        return valid;
      }
    }
  );
}
